/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace component-selector */

import {
  Component,
  OnInit,
  OnDestroy,
  AfterViewInit
}                                from '@angular/core';

import { Subscription          } from 'rxjs';

import { AuthenticationService } from '../../services/authentication.service';
import { AlertService }          from '../../services/alert.service';

import { Logger                } from '../../util/logger';
import { User                  } from '../../models/user';
import Timeout = NodeJS.Timeout;
import {
  Router
}                                from '@angular/router';

@Component({
  selector:    '.drop-user-details',
  template: `
    <div *ngIf="!user; else userdropfill">No User</div>
    <ng-template #userdropfill>
      <span [innerHTML]="profilePic"></span>
      <span class="dropmenu-title">{{user.firstName}} {{user.lastName}}</span>
      <div class="dropmenu-down-content right" style="padding: 0;">
        <table colspan="0" cellspacing="0" style="margin: 12px;">
          <tr>
            <td style="text-align: right; padding-right: 12px;">eMail:</td><td>{{user.email}}</td>
          </tr>
          <tr>
            <td style="text-align: right; padding-right: 12px;">user:</td><td>{{user.username}}</td>
          </tr>
          <tr>
            <td style="text-align: right; padding-right: 12px;">auth:</td><td>{{user.token}}</td>
          </tr>
          <tr>
            <td style="text-align: right; padding-right: 12px;">Expires:</td><td [innerHTML]="expiresLabel"></td>
          </tr>
          <tr>
            <td style="padding-right: 12px;"><button class="gui-button primary" (click)="onRefresh()">Refresh</button></td>
          </tr>
        </table>
      </div>
    </ng-template>
  `
})

/**
 *
 * @class UserDropdown
 *
 * @brief helper drop down to show logged in user details.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2020
 *
 */
export class UserDropdownComponent implements OnInit, OnDestroy, AfterViewInit {

  /** the the currently logged in user */
  public user: User = null;

  /** the observable for the logged in user */
  private userWatch: Subscription;

  /** the count down to expiry */
  public expiresLabel: string = '';

  /** user profile pic if we have one */
  public profilePic: string = '';

  /** id for our count down timer */
  private countDownTimer: number = 0;

  constructor(
    private auth:   AuthenticationService,
    private alerts: AlertService,
    private router: Router
  ) {

    Logger.debug('[UserDropDown]', 'constructing...');

  }

  ngAfterViewInit(): void {

    this.setTimer();
  }

  /** @brief set up the dockable views and view manager */
  ngOnInit(): void {

    /*
     * watch for the logged in user to go null, it means we've been logged out
     * somehow, session timeout, SSO validation fail, or manual logout.
     *
     */

    this.userWatch = this.auth.observableUser
      .subscribe(user => {

        Logger.debug('[UserDropDown] user switched to: ', user);

        this.user = user;

        return;
      });
  }

  ngOnDestroy() {

    /* stop watching the logged in user */

    this.userWatch.unsubscribe();
  }

  /** (re)set the count down timer for when our session expires */
  setTimer() {

    if (this.countDownTimer) {

      window.clearInterval(this.countDownTimer);

    }

    /*
     * every second update the count down timer for session expiry...if we are within
     * 3 seconds of logout time, auto-logout.
     *
     */

    this.countDownTimer = window.setInterval((self) => {

      if (!self.user || self.user === undefined) {

        self.user = self.auth.userOfSession;

      }

      if (!self.user) {

        /* no user yet */

        return ;
      }

      /* set the profile pic if we can */

      this.profilePic = `<img class="userprofileicon" src="/assets/images/profile-512.png">`;

      if ((typeof self.user.options != 'undefined') && (self.user.options != null)) {

        if ((typeof self.user.options.picture != 'undefined') && (self.user.options.picture != null)) {

          this.profilePic = `<img class="userprofileicon"  src="${self.user.options.picture}">`;
        }

      }

      /* check for session expiry */

      const now: number = Math.floor(Date.now() / 1000);

      if (now >= self.user.expiryAt) {

        /* require login, session expired */

        window.clearInterval(this.countDownTimer);

        this.countDownTimer = 0;

        this.user = null;

        self.alerts.info(`Session expired, requiring login...`, {autoClose: true});

        self.router.navigate(['/login'], { queryParams: { returnUrl: '/ide' }});

        return ;
      }

      const delta = self.user.expiryAt - now;

      if (delta === 59) {

        /* 1 minute warning */

        self.alerts.warn(`Session expires in 60 seconds`, {autoClose: true});

      }

      if (delta === 29) {

        /* 30 second warning */

        self.alerts.error(`Session expires in 30 seconds`, {autoClose: true});

      }

      if (delta === 9) {

        /* 10 second warning */

        self.alerts.error(`Session expires in 10 seconds`, {autoClose: true});

      }

      const h = Math.floor(delta / 3600);
      const m = Math.floor(delta % 3600 / 60);
      const s = Math.floor(delta % 3600 % 60);

      self.expiresLabel = `<span class="countdown-time">${h}:${m}:${s}</span>`;

      if (delta <= 60) {

        self.expiresLabel  = `<span class="countdown-time countdown-warning">${h}:${m}:${s}</span>`;
      }

      if (delta <= 30) {

        self.expiresLabel  = `<span class="countdown-time countdown-critical">${h}:${m}:${s}</span>`;
      }

    }, 1000, this);
  }

  /** refresh the current login session */
  onRefresh() {

    Logger.debug('[UserDropDown] session refreshing...');

    this.auth.refresh().subscribe((user: User) => {

        Logger.debug('[UserDropDown] updated user: ', user);

      },
      (error) => {

        Logger.error('[UserDropDown] could not refresh user: ', error);
      });
  }

}
